import { render } from "./Shopify.vue?vue&type=template&id=0417091c&scoped=true"
import script from "./Shopify.vue?vue&type=script&lang=js"
export * from "./Shopify.vue?vue&type=script&lang=js"

import "./Shopify.vue?vue&type=style&index=0&id=0417091c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0417091c"]])

export default __exports__